var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Dialog",
    {
      ref: "dialog",
      attrs: {
        title: _vm.$t("title.agency.userImportList"),
        width: "700px",
        color: "next"
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "back",
                  staticStyle: { "font-size": "16px" },
                  attrs: { width: "33%", dark: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("button.close")) + "\n    ")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "v-container",
        [
          _c("v-data-table", {
            staticClass: "elevation-1",
            attrs: {
              "calculate-widths": "",
              headers: _vm.headers,
              items: _vm.records,
              "loading-text": _vm.$t("description.userImportReading"),
              "no-data-text": _vm.$t("error.userImportNotFound"),
              options: _vm.options,
              "footer-props": {
                itemsPerPageText: "1ページあたりの行数",
                itemsPerPageOptions: _vm.itemsPerPageOptions
              }
            },
            on: {
              "update:options": function($event) {
                _vm.options = $event
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "item.detail",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "v-menu",
                        {
                          attrs: { "offset-y": "", left: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            color: "red",
                                            fab: "",
                                            "x-small": "",
                                            dark: ""
                                          }
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          { attrs: { color: "white" } },
                                          [_vm._v("edit")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _c(
                            "v-list",
                            { staticClass: "ma-0 pa-0" },
                            [
                              _c(
                                "v-list-item",
                                {
                                  on: {
                                    click: function($event) {
                                      return _vm.onClickDelete(item)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("delete")]),
                                  _c(
                                    "v-list-item-action",
                                    {
                                      staticClass: "mx-0",
                                      attrs: { dark: "", color: "next" }
                                    },
                                    [_vm._v(_vm._s(_vm.$t("button.delete")))]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _c("DeleteDialog", {
        ref: "userImportDeleteDialog",
        attrs: { title: _vm.$t("title.agency.userImportDelete") },
        on: { onSuccess: _vm.onSuccessDeleteUserImport }
      }),
      _c("CompletedDialog", { ref: "completedDialog" }),
      _c("ErrorDialog", { ref: "errorDialog" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }